import { pgTable, primaryKey, unique, uuid, foreignKey, boolean, } from 'drizzle-orm/pg-core';
import { sortOrder, tableBase } from '../utils';
import { AdminLibraryExercise } from './exercise-library';
import { settingsColumns } from '../settings-columns';
import { DEFAULT_PROFILE_ROLE, ProfileRoleType } from '../enums';
export const AdminDefaultOrgSettings = pgTable('admin_default_org_settings', {
    ...tableBase,
    ...settingsColumns,
    enableTeamLibrary: boolean('enable_team_library').notNull().default(false),
    showBaseLibrary: boolean('show_base_library').notNull().default(false),
    defaultCoachRole: ProfileRoleType('default_coach_role')
        .notNull()
        .default(DEFAULT_PROFILE_ROLE),
}, (table) => ({
    pk: primaryKey({ columns: [table.id] }),
}));
export const AdminDefaultBenchmarkCoreExercise = pgTable('admin_default_benchmark_core_exercise', {
    ...tableBase,
    libraryExerciseId: uuid('library_exercise_id').notNull(),
    sortOrder,
}, (table) => ({
    pk: primaryKey({ columns: [table.id] }),
    uq1: unique().on(table.libraryExerciseId),
    uq2: unique().on(table.sortOrder),
    exerciseFk: foreignKey({
        columns: [table.libraryExerciseId],
        foreignColumns: [AdminLibraryExercise.id],
    }),
}));
//# sourceMappingURL=default-org-settings.js.map